var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcEstrella(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#91DDCF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7387 7.2704L23.3925 15.9242C23.5079 16.2704 23.8541 16.4435 24.2002 16.4435H32.8541C33.7195 16.4435 34.0656 17.5973 33.3733 18.1166L26.3348 23.3089C26.0464 23.5396 25.931 23.9435 26.0464 24.2896L29.3925 33.1742C29.6233 33.9819 28.7579 34.6742 28.0656 34.155L20.5079 28.5012C20.2195 28.2704 19.8156 28.2704 19.4695 28.5012L11.8541 34.155C11.1618 34.6742 10.2387 33.9819 10.5272 33.1742L13.7579 24.2896C13.8733 23.9435 13.7579 23.5396 13.4695 23.3089L6.431 18.1166C5.73869 17.5973 6.14254 16.4435 6.95023 16.4435H15.6041C16.0079 16.4435 16.2964 16.3281 16.4118 15.9242L19.1233 7.2127C19.3541 6.40501 20.5079 6.4627 20.7387 7.2704ZM19.931 12.8671C19.9233 13.6562 19.9233 24.8327 19.9233 25.3824C20.0309 25.4702 21.6155 26.6479 24.6769 28.9156C25.0807 29.2184 25.5853 28.8147 25.4508 28.3437L23.5628 23.3774C23.3616 22.9332 23.5628 22.6439 23.8117 22.4917L27.7723 19.7289C28.176 19.4261 27.9741 18.7532 27.4694 18.7532H22.8198C22.618 18.7532 22.0879 18.6858 21.944 18.167L20.404 13.2371C20.3373 13.0036 20.1312 12.8776 19.931 12.8671Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEstrella);
export default __webpack_public_path__ + "static/media/ic_estrella.e64d1dfdd18162b8263ed269bba9e639.svg";
export { ForwardRef as ReactComponent };